export type AccountKind = "customer" | "partner";
export type AuthWorkspace = { isOwner: boolean; isPartner: boolean; partnerApplicationStatus?: string | null };

export function safePostAuthRedirect(value: unknown): string | undefined {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) return undefined;
  return value;
}

export function postAuthDestination(input: {
  kind: AccountKind;
  session: AuthWorkspace;
  requested?: unknown;
  stored?: unknown;
}): string {
  const permitted = (path: string) => {
    if (path === "/owner" || path.startsWith("/owner/")) return input.session.isOwner;
    if (path === "/partner" || path.startsWith("/partner/")) return input.session.isOwner || input.session.isPartner || path === "/partner/apply";
    return true;
  };
  const requested = safePostAuthRedirect(input.requested);
  const stored = safePostAuthRedirect(input.stored);
  if (requested && permitted(requested)) return requested;
  if (stored && permitted(stored)) return stored;
  if (input.session.isOwner) return "/owner";
  if (input.kind === "partner") return input.session.isPartner ? "/partner" : "/partner/apply";
  return "/customer";
}
